import { ChangeDetectorRef, Component, ElementRef, inject, OnInit, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DeviceDetectorService } from 'ngx-device-detector';
import { MaterialModule } from '../../../shared/material/material.module';
import { DocumentSharingComponent } from '../../../shared/document-sharing/document-sharing.component';
import { UserPreferencesCacheService } from '../../../shared/services/user-preferences-cache.service';
import { ProfileProviderPJCacheListService } from '../../../shared/services/profile-provider-pj-cache-list.service';
import {
  DocumentSharingControllerService,
  ProfileProviderPJ,
} from '../../../core/generated';
import { isValidCNPJFormat } from '../../../shared/utils/validators';
import { firstValueFrom } from 'rxjs';
import { ContainerComponent } from '../../../shared/container/container.component';

@Component({
    selector: 'app-share-documents-profile-pf',
    standalone: true,
    imports: [CommonModule, MaterialModule, DocumentSharingComponent, ContainerComponent],
    templateUrl: './share-documents-profile-pf.component.html',
    styleUrl: './share-documents-profile-pf.component.scss'
})
export class ShareDocumentsProfilePFComponent implements OnInit {

  UserPreferencesCacheService = inject(UserPreferencesCacheService);
  deviceService = inject(DeviceDetectorService);
  profileProviderPJCacheService = inject(ProfileProviderPJCacheListService);
  isMobile = this.deviceService.isMobile();
  cdr = inject(ChangeDetectorRef);
  documentSharingService = inject(DocumentSharingControllerService);
  user!: any;
  sharedCompany: ProfileProviderPJ | undefined;
  isLoading = false;
  @ViewChild(DocumentSharingComponent)
  documentSharingComponent?: DocumentSharingComponent;
  @ViewChild('cnpj') cnpjInput?: ElementRef<HTMLInputElement>;

  ngOnInit(): void {
    this.isMobile = this.deviceService.isMobile();
    this.UserPreferencesCacheService.getUser().subscribe((user) => {
      this.user = user;
    });
  }

  async shareDocuments(): Promise<void> {

    const documentSharing = {
      grantedCompanyCnpj: this.sharedCompany?.cnpj!,
      ownerDocumentsCpfCnpj: this.user.cpf,
      active: true,
    };


    const response = await firstValueFrom(
      this.documentSharingService.create(documentSharing)
    );

    if (this.documentSharingComponent) {
      const currentList = this.documentSharingComponent.documentSharing || [];
      this.documentSharingComponent.documentSharing = [response, ...currentList];

      this.cdr.detectChanges();
      this.cdr.markForCheck();
    }

    this.sharedCompany = undefined;

    if (this.cnpjInput) {
      this.cnpjInput.nativeElement.value = '';
    }

  }

  searchCompany(cnpj: string): void {
    this.sharedCompany = undefined;
    const cleanCnpj = cnpj.replace(/[.\-\/]/g, '');

    if (!isValidCNPJFormat(cleanCnpj)) {
      console.error('CNPJ inválido');
      return;
    }

    this.profileProviderPJCacheService.findProfileProviderPJByCnpj(cleanCnpj, (company) => {
      if (company) {
        this.sharedCompany = company;
        this.cdr.detectChanges();
      }
    });
    
    if (this.cnpjInput) {
      this.cnpjInput.nativeElement.value = '';
    }
  }
}
